import withStyles from '@mui/styles/withStyles';
import {PAGE_HEIGHT_WITH_NAVBAR} from "common/helpers";
import {color, space} from "common/tokens";
import React, {useEffect} from 'react';
import '../common/styles/animate.css';
import ChatWindow from "components/Chat/ChatWindow";
import MeetingSummaryRating from "components/Chat/MeetingSummaryRating";
import {loadEmojiPicker} from "components/Chat/MessageInputBox";
import {useHistory, useLocation} from "react-router-dom";

// The chat fills the page and scrolls inside its own panes, so the page itself
// does not scroll. Video lives on its own route — the chat tab is only chat.
const MaterialStyles = theme => ({
  mainWrapper: {
    background: color.SURFACE,
    height: PAGE_HEIGHT_WITH_NAVBAR,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  container: {
    width: '100%',
    maxWidth: space.CONTAINER_MAX,
    margin: '0 auto',
    padding: '24px 32px 32px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    flex: 1,
    [theme.breakpoints.down('md')]: {
      padding: '16px 16px 20px',
    },
  },
});

const ChatFullScreen = ({classes, setCurrentPath, getMeetingRatingStatus, meetingSummaryRating, storeMeetingSummaryRating, id}) => {
  useEffect(() => {
    setCurrentPath('chat');
    getMeetingRatingStatus()
    loadEmojiPicker();
  }, []);

  const userId = id;
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    if (queryParams.has('section')) {
      queryParams.delete('section');
      history.replace({
        search: queryParams.toString(),
      });
    }

    // Handle channel_id from deep link - store it for ChatWindow to use
    if (queryParams.has('channel_id')) {
      const channelId = queryParams.get('channel_id');
      // Store in localStorage so ChatWindow can access it
      localStorage.setItem('openChannelId', channelId);
      // Remove from URL after storing
      queryParams.delete('channel_id');
      // Also handle notification_id if present
      if (queryParams.has('notification_id')) {
        queryParams.delete('notification_id');
      }
      history.replace({
        search: queryParams.toString(),
      });
    }
  }, [location, history]);

  return (
    <>
      {meetingSummaryRating && meetingSummaryRating?.meetingRatingStatus &&
        (
          <MeetingSummaryRating
            meetingSummaryRating={meetingSummaryRating}
            storeMeetingSummaryRating={storeMeetingSummaryRating}
            userId={userId}
            getMeetingRatingStatus={getMeetingRatingStatus}
          />
        )
      }
      <div className={classes.mainWrapper}>
        <div className={classes.container}>
          <ChatWindow/>
        </div>
      </div>
    </>
  )
};

ChatFullScreen.sections = {
  CHAT: 'chat',
  VIDEO: 'video',
};

export default withStyles(MaterialStyles)(ChatFullScreen);
